export default __webpack_public_path__ + "static/media/womens.0c453b44.jpg";